import { Helmet } from "react-helmet-async"
import { useOutletContext } from "react-router"
import {
	OAuthAppPermissions,
	TOAuthIntegration,
} from "../../../../../Integrations"

export default function OAuthIntegrationPermissionsPage() {
	const context = useOutletContext<{ integration: TOAuthIntegration }>()

	return (
		<>
			<Helmet>
				<title>Permissions | OAuth App</title>
			</Helmet>
			<OAuthAppPermissions integration={context.integration} />
		</>
	)
}
